<template>
    <v-dialog v-model="dialog" max-width="690px">
        <v-overlay color="#106c68" :value="loadingState" z-index="12">
            <span class="loader"></span>
        </v-overlay>
        <v-card class="standard-row upload-attach-file-card">
            <v-row no-gutters class="standard-row" style="padding: 29px 4% 5px 4%;">
                <v-col cols="12" sm="auto" md="auto" lg="auto" class="pr-sm-3 set-center-upload-attach-file">
                    <svg width="35" class="mt-1" height="35" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.35272 3.00781H2.88792C2.29585 3.00781 1.72803 3.22892 1.30937 3.62249C0.890717 4.01607 0.655518 4.54987 0.655518 5.10647V28.1917C0.655518 28.7482 0.890717 29.2821 1.30937 29.6756C1.72803 30.0692 2.29585 30.2903 2.88792 30.2903H25.2119C25.804 30.2903 26.3718 30.0692 26.7905 29.6756C27.2091 29.2821 27.4443 28.7482 27.4443 28.1917V5.10647C27.4443 4.54987 27.2091 4.01607 26.7905 3.62249C26.3718 3.22892 25.804 3.00781 25.2119 3.00781H20.7471" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.0499 11.4015V24.1109M20.7471 17.6974H7.35266M9.58506 0.908203H18.5147C19.1067 0.908203 19.6745 1.12931 20.0932 1.52288C20.5119 1.91646 20.7471 2.45026 20.7471 3.00686C20.7471 3.56345 20.5119 4.09725 20.0932 4.49083C19.6745 4.8844 19.1067 5.10551 18.5147 5.10551H9.58506C8.99299 5.10551 8.42517 4.8844 8.00652 4.49083C7.58786 4.09725 7.35266 3.56345 7.35266 3.00686C7.35266 2.45026 7.58786 1.91646 8.00652 1.52288C8.42517 1.12931 8.99299 0.908203 9.58506 0.908203V0.908203Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </v-col>
                <v-col cols="12" sm="auto" md="auto" lg="auto" class="font-theme font-size-header-upload-attach-file-create set-center-upload-attach-file">
                    Upload เอกสารแนบ
                </v-col>
            </v-row>
            <v-row class="standard-row" style="padding: 0 4%;">
                <v-card v-show="!uploadAttachFiles.length" :style="`background-color: ${uploadBackgroundCard};`" outlined @dragover="fileDragOver($event)" @dragleave="fileDragLeave()" @drop="fileDrop($event)" class="upload-card">
                    <input type="file" multiple ref="uploadAttachment" class="upload-doc-input" @click="resetInput()" @change="getAttachFile()">
                    <v-row justify="center" class="standard-row d-flex align-center" style="background-color: rgba(217, 217, 217, 0.44); height: 100%; width: 100%; border-radius: 20px;">
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.7646 1.69141H7.74756C6.02138 1.69141 4.36591 2.38118 3.14532 3.60898C1.92473 4.83678 1.23901 6.50203 1.23901 8.2384V40.9734C1.23901 42.7098 1.92473 44.375 3.14532 45.6028C4.36591 46.8306 6.02138 47.5204 7.74756 47.5204H40.2903C42.0165 47.5204 43.6719 46.8306 44.8925 45.6028C46.1131 44.375 46.7988 42.7098 46.7988 40.9734V8.2384" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M33.7815 24.6055L24.0187 34.426L14.2559 24.6055" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M46.7985 1.69141H33.7814C31.1921 1.69141 28.7089 2.72606 26.878 4.56776C25.0471 6.40946 24.0186 8.90734 24.0186 11.5119V34.4264" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </v-row>
                </v-card>
                <v-card v-show="uploadAttachFiles.length" style="background-color: rgba(217, 217, 217, 0.44);" class="upload-card elevation-0 scroll-upload-attach-file">
                    <v-row no-gutters class="standard-row font-theme pt-5 pl-5">
                        <v-btn icon style="font-size: 30px; font-weight: 700; color: black; margin-top: 7px;" @click="addMoreFile()">+</v-btn>
                        <span style="font-size: 30px; font-weight: 700; color: black;">เอกสารแนบ</span>
                    </v-row>
                    <v-row no-gutters align="center" class="standard-row font-theme pt-5 pl-5 pr-5" :class="{ 'pb-5' :  indexFile === uploadAttachFiles.length - 1}" v-for="(files, indexFile) in uploadAttachFiles" :key="`${files}${indexFile}${uploadAttachFiles.length>1}`">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="(files.account_id == raDetail.account_id && uploadAttachFiles.length > 1)" v-on="on" v-bind="attrs" icon @click="deleteFile(indexFile,files)">
                                    <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 2H12" stroke="#C71919" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </v-btn>
                                <!-- <v-btn icon v-on="on" v-bind="attrs" @click="downloadAttachFile(files)">
                                    <v-icon color="#28a745">mdi-download</v-icon>
                                </v-btn> -->
                            </template>
                            <span class="font-theme">{{ (!files.file_id || files.account_id == raDetail.account_id)? 'ลบเอกสารแนบ': '' }} : {{ files.name.includes(".")? files.name.substr(0, files.name.lastIndexOf(".")): files.name }}</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <!-- <v-btn v-if="!files.file_id || (files.account_id == raDetail.account_id && uploadAttachFiles.length > 1)" v-on="on" v-bind="attrs" icon @click="deleteFile(indexFile,files)">
                                    <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 2H12" stroke="#C71919" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </v-btn> -->
                                <v-btn icon v-on="on" v-bind="attrs" @click="downloadAttachFile(files)">
                                    <v-icon color="#28a745">mdi-download</v-icon>
                                </v-btn>
                            </template>
                            <span class="font-theme">{{ 'ดาวน์โหลดเอกสารแนบ' }} : {{ files.name.includes(".")? files.name.substr(0, files.name.lastIndexOf(".")): files.name }}</span>
                        </v-tooltip>
                        <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M26 20.5V9.125L17.0714 1H8.14284C7.19564 1 6.28723 1.34241 5.61746 1.9519C4.94769 2.5614 4.57141 3.38805 4.57141 4.25V20.5C4.57141 21.362 4.94769 22.1886 5.61746 22.7981C6.28723 23.4076 7.19564 23.75 8.14284 23.75H22.4286C23.3758 23.75 24.2842 23.4076 24.9539 22.7981C25.6237 22.1886 26 21.362 26 20.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1 4.25V20.5C1 22.2239 1.75255 23.8772 3.09209 25.0962C4.43164 26.3152 6.24845 27 8.14286 27H22.4286M17.0714 1V5.875C17.0714 6.73695 17.4477 7.5636 18.1175 8.1731C18.7872 8.78259 19.6957 9.125 20.6429 9.125H26" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="pl-2 text-truncate" style="font-size: 18px;">{{ files.name.includes(".")? files.name.substr(0, files.name.lastIndexOf(".")).length > 45? `${files.name.substr(0, files.name.lastIndexOf(".")).substring(0, 20)} . . . ${files.name.substr(0, files.name.lastIndexOf(".")).substring(files.name.substr(0, files.name.lastIndexOf(".")).length - 20)}`: files.name.substr(0, files.name.lastIndexOf(".")) : files.name }}</span>
                        <v-btn v-if="['gif', 'jpg', 'jpeg', 'png', 'tif', 'pdf'].includes(files.name.split('.').pop())" dark depressed icon @click="openPDFModal(files, indexFile)" color="black" class="ml-auto">
                            <v-icon v-if="indexLoadingFile == indexFile" color="#28a745">mdi-spin mdi-loading</v-icon>
                            <v-icon v-else color="#28a745">mdi-eye-outline</v-icon>
                        </v-btn>
                    </v-row>
                </v-card>
            </v-row>
            <v-row class="standard-row text-center d-flex justify-center upload-attach-file-row">
                <v-btn height="31" color="#0B68D6" @click="closeDialog()" class="font-theme white--text upload-attach-file-btn">
                    ยืนยัน
                </v-btn>
            </v-row>
        </v-card>
        <PreviewPdfModal />
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
import PreviewPdfModal from '../components/PreviewPdfModal.vue'
    export default {
        components: {
            PreviewPdfModal
        },
        data: () => ({
            dialog: false,
            statusDocument: false,
            loadingState: false,
            uploadAttachFiles: [],
            uploadBackgroundCard: 'transparent',
            indexLoadingFile: null,
            listAttachFile: [],
            transactionId: "",
            transactionDetail: [],
            fromPage: null,
            fromNew : '',
        }),
        mounted () {
            EventBus.$on('downloadFileFromCSPO', this.openDialog)
        },
        beforeDestroy () {
            EventBus.$off('downloadFileFromCSPO')
        },
        computed: {
            raDetail() {
                return this.$store.state.raDetail
            },
        },
        methods: {
            openDialog(file = [], statusDocument = false,transaction_id, fromNew , from) {
                this.transactionId = transaction_id
                this.dialog            = true
                this.statusDocument    = statusDocument || false
                this.uploadAttachFiles = file
                this.fromPage          = from || null
                this.fromNew           = fromNew || ''
                this.getListFiles()
            },
            closeDialog() {
                EventBus.$emit('sendAttachmentFileToCreate', this.uploadAttachFiles)
                this.dialog = false
            },
            fileDragOver(event) {
                event.preventDefault()
                if(this.uploadBackgroundCard != '#D9D9D9') {
                    this.uploadBackgroundCard = '#D9D9D9'
                }
            },
            fileDragLeave() {
                this.uploadBackgroundCard = 'transparent'
            },
            fileDrop(event) {
                event.preventDefault()
                this.$refs.uploadAttachment.files = event.dataTransfer.files
                this.getAttachFile()
                this.uploadBackgroundCard = 'transparent'
            },
            getAttachFile() {
                if(this.$refs.uploadAttachment.files.length > 0) {
                    for(let i=0; i < this.$refs.uploadAttachment.files.length; i++) {
                        this.uploadAttachFiles.push(this.$refs.uploadAttachment.files[i])
                    }
                }
                this.uploadAttachFileToAPI(this.$refs.uploadAttachment.files)
            },
            resetInput() {
                this.$refs.uploadAttachment.value = '';
            },
            addMoreFile() {
                this.$refs.uploadAttachment.click()
            },
            async deleteFile(index,file) {
                // if (index >= 0) {
                //     this.uploadAttachFiles.splice(index, 1)
                // }
                if(file.file_id){
                    try {
                        this.loadingState = true
                        const data = await this.axios.delete(`${this.$api_url}/attach_file/api/v1/delete_file?file_id=${file.file_id}`)
                        if (data.status) {
                            await this.getListFiles()
                        }
                    } catch (error) {
                        console.log(error);
                    }finally{
                        this.loadingState = false
                    }
                }else{
                    this.uploadAttachFiles.splice(index, 1)
                }
            },
            async getListFiles() {
                try {
                    this.loadingState = true
                    this.listAttachFile = []
                    const { data } = await this.axios.get(`${this.$api_url}/attach_file/api/v1/list_attachment_file?transaction_id=${this.transactionId}&from=${this.fromPage}`)
                    if (data.status && data.data.length) {
                        this.listAttachFile = data.data
                        for (let i = 0; i < this.listAttachFile.length; i++) {
                            this.listAttachFile[i].name = this.listAttachFile[i].file_name
                            delete this.listAttachFile[i].file_name
                        }
                        this.uploadAttachFiles = this.listAttachFile
                    }
                } catch (error) {
                    this.loadingState = false
                    console.log(error)
                } finally {
                    this.loadingState = false
                }
            },
            async uploadAttachFileToAPI(new_files) {
                if (!this.transactionId || !new_files.length) {
                    // this.alert('อับโหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                    return
                }
                try {
                    this.loadingState = true
                    let formData = new FormData()
                    formData.append('transaction_id', this.transactionId)
                    formData.append('from', this.fromPage)
                    for (let i = 0; i < new_files.length; i++) {
                        formData.append('file', new_files[i])
                    }
                    const { data } = await this.axios.post(`${this.$api_url}/attach_file/api/v1/save_file`, formData)
                    if(data.status) {
                        await this.getListFiles()
                    } else {
                        this.alert('อับโหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('อับโหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                } finally {
                    this.loadingState = false
                }
            },
            async openPDFModal(files, index) {
                if (files?.file_id) {
                    try {
                        this.indexLoadingFile = index
                        const data = await this.axios.get(`${this.$api_url}/attach_file/api/v1/view_file?file_id=${files.file_id}`, { responseType: "blob" })
                        if (data.data) {
                            const temp_file = {
                                name: files.name,
                                type: files.type
                            }
                            EventBus.$emit('openPDFModal', data.data, temp_file)
                        }
                    } catch (error) {
                        console.log(error);
                        this.alert('ไม่พบข้อมูลในระบบ', 'Fail', 'error')
                    } finally {
                        this.indexLoadingFile = null
                    }
                } else {
                    const temp_file = files.name.split('.').pop()
                    EventBus.$emit('openPDFModal', files, temp_file)
                }
            },
            async downloadAttachFile(files) {
                if (!Object.keys(files).length) {
                    return this.alert('ดาวน์โหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                }
                try {
                    this.loadingState = true
                    var file_id_name = files.file_id? files.file_id: files.name
                    const params = {
                               file_id: file_id_name,
                            // ...(this.fromNew === 'Odoo' && {
                                sale_document: this.transactionId
                            // })
                    }
                    const data = await this.axios.get(`${this.$api_url}/attach_file/api/v1/download_file`,
                         {
                            params,
                            responseType: "blob"
                        }
                    )
                    if (data.data) {
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(new Blob([ data.data ],{type:'application/zip'}))
                        link.setAttribute("download", files.name);
                        document.body.appendChild(link);
                        link.click()
                        this.alert('ดาวน์โหลดไฟล์แนบสำเร็จ', 'Success', 'success')
                    } else {
                        this.alert('ดาวน์โหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    console.log(error);
                    this.alert('ดาวน์โหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                } finally {
                    this.loadingState = false
                    // this.alert('ดาวน์โหลดไฟล์แนบสำเร็จ', 'Success', 'success')
                }
            },
            alert(title = '', text = 'Warning', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        }
    }
</script>

<style>

    .font-size-header-upload-attach-file-create {
        font-size: calc(100% + 1.1vw);
        font-weight: 400;
    }

    .upload-attach-file-row {
        padding-top: 17px;
        padding-bottom: 20px;
    }

    .upload-attach-file-btn {
        border-radius: 8px;
        font-size: 20px;
        font-weight: 700;
        box-shadow: none;
    }

    .upload-card {
        width: 100%;
        min-height: 222px;
        border-radius: 20px !important;
    }

    .upload-doc-input {
        opacity: 0;
        overflow: hidden;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        width: 100%;
        height: 100%;
        z-index: 1;
        border-radius: 20px !important;
    }

    .scroll-upload-attach-file {
        max-height: calc(100vh - 254px);
        overflow-y: auto;
    }

    .scroll-upload-attach-file::-webkit-scrollbar {
        width: 12px;
    }

    .scroll-upload-attach-file::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .scroll-upload-attach-file::-webkit-scrollbar {
        width: 8px;
        background-color: transparent !important;
    }

    .scroll-upload-attach-file::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #D9D9D9;
    }

    .upload-attach-file-card {
        border-radius: 20px !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    }

    @media only screen and (max-width: 600px) {
        
        .set-center-upload-attach-file {
            text-align: center;
        }
    }
</style>